<div class="d-inline-block" ngbDropdown>
  <div class="sorting-icon">
    <rs-web-icon
      [cursor]="'pointer'"
      [icon]="ImmomioIconName.Sorting"
      [size]="16"
      ngbDropdownToggle
    >
    </rs-web-icon>
  </div>
  <div aria-labelledby="dropdownBasic1" ngbDropdownMenu class="select-menu-dropdown">
    <button class="sort-header primary-text" ngbDropdownItem>{{ 'sorting_l' | translate }}</button>
    @for (label of labels; track label.key) {
      <div class="d-flex">
        <button class="d-flex primary-text" ngbDropdownItem (click)="selectSorting(label)">
          {{ label.key | translate }}
          @if (selectedSorting$ | async; as selectedSorting) {
            @if (
              selectedSorting.value === label.value && selectedSorting.direction === label.direction
            ) {
              <rs-web-icon
                class="sort-checked"
                [icon]="ImmomioIconName.Check"
                [size]="20"
                [otherClasses]="['primary-text']"
              ></rs-web-icon>
            }
          }
        </button>
      </div>
    }
  </div>
</div>
